import L from 'leaflet';

/**
 * Patch Leaflet prototypes to prevent unhandled exceptions and spurious console warnings
 * during teardown, animations, and headless browser runs.
 */
if (typeof window !== 'undefined' && L) {
  // 1. Guard Canvas _draw and _redraw against null/undefined canvas 2D contexts
  // which occur when an animation frame fires after or during map destruction.
  if (L.Canvas) {
    const CanvasProto = L.Canvas.prototype as unknown as {
      _draw?: (...args: unknown[]) => unknown;
      _redraw?: (...args: unknown[]) => unknown;
      _ctx?: CanvasRenderingContext2D | null;
    };

    const origDraw = CanvasProto._draw;
    if (typeof origDraw === 'function') {
      CanvasProto._draw = function (...args: unknown[]) {
        if (!this._ctx) return;
        return origDraw.apply(this, args);
      };
    }

    const origRedraw = CanvasProto._redraw;
    if (typeof origRedraw === 'function') {
      CanvasProto._redraw = function (...args: unknown[]) {
        if (!this._ctx) return;
        return origRedraw.apply(this, args);
      };
    }
  }

  // 2. Guard Evented _on against undefined listener functions which produce console warnings.
  if (L.Evented) {
    const EventedProto = L.Evented.prototype as unknown as {
      _on?: (type: unknown, fn: unknown, context?: unknown, _once?: unknown) => unknown;
    };

    const origOn = EventedProto._on;
    if (typeof origOn === 'function') {
      EventedProto._on = function (type: unknown, fn: unknown, context?: unknown, _once?: unknown) {
        if (typeof fn !== 'function') return this;
        return origOn.call(this, type, fn, context, _once);
      };
    }
  }
}
